'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _desc, _value, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _GeographyChart = require('components/Statistics/GeographyChart/GeographyChart');

var _GeographyChart2 = _interopRequireDefault(_GeographyChart);

var _FilterButton = require('components/FilterButton/FilterButton');

var _FilterButton2 = _interopRequireDefault(_FilterButton);

var _statistics = require('helpers/statistics');

var _Checkbox = require('components/Checkbox/Checkbox');

var _Checkbox2 = _interopRequireDefault(_Checkbox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var styles = require('./GeographyChartTypeWrapper.scss');

var CHART_TYPE = {
  plays: 'plays',
  downloads: 'downloads'
};

var DISPLAY_TYPE = {
  markers: 'markers',
  regions: 'regions'
};

var GeographyChartTypeWrapper = (_class = (_temp = _class2 = function (_PureComponent) {
  (0, _inherits3.default)(GeographyChartTypeWrapper, _PureComponent);

  function GeographyChartTypeWrapper() {
    var _ref;

    (0, _classCallCheck3.default)(this, GeographyChartTypeWrapper);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = GeographyChartTypeWrapper.__proto__ || (0, _getPrototypeOf2.default)(GeographyChartTypeWrapper)).call.apply(_ref, [this].concat(args)));

    _this.state = { chartType: CHART_TYPE.plays, displayMarkers: false };
    return _this;
  }

  (0, _createClass3.default)(GeographyChartTypeWrapper, [{
    key: 'getData',
    value: function getData() {
      var _props = this.props,
          countriesDownloadsData = _props.countriesDownloadsData,
          countriesPlaysData = _props.countriesPlaysData,
          citiesDownloadsData = _props.citiesDownloadsData,
          citiesPlaysData = _props.citiesPlaysData;
      var _state = this.state,
          chartType = _state.chartType,
          displayMarkers = _state.displayMarkers;

      return chartType === CHART_TYPE.plays ? displayMarkers ? citiesPlaysData : countriesPlaysData : displayMarkers ? citiesDownloadsData : countriesDownloadsData;
    }
  }, {
    key: 'togglePlays',
    value: function togglePlays() {
      this.setState({ chartType: CHART_TYPE.plays });
    }
  }, {
    key: 'toggleDownloads',
    value: function toggleDownloads() {
      this.setState({ chartType: CHART_TYPE.downloads });
    }
  }, {
    key: 'toggleDisplayMode',
    value: function toggleDisplayMode() {
      this.setState({ displayMarkers: !this.state.displayMarkers });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          loading = _props2.loading,
          id = _props2.id;
      var t = this.context.t;
      var _state2 = this.state,
          chartType = _state2.chartType,
          displayMarkers = _state2.displayMarkers;

      var statName = chartType === CHART_TYPE.plays ? t('Plays') : t('Downloads');
      var displayMode = displayMarkers ? DISPLAY_TYPE.markers : DISPLAY_TYPE.regions;
      var data = this.getData();

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_GeographyChart2.default, {
          data: data,
          statName: statName,
          loading: loading,
          id: id,
          displayMode: displayMode
        }),
        _react2.default.createElement(
          'div',
          { className: styles.buttons },
          _react2.default.createElement(
            'div',
            { className: styles.toggler },
            _react2.default.createElement(_FilterButton2.default, {
              onClick: this.togglePlays,
              title: t('Number of plays'),
              isActive: chartType === CHART_TYPE.plays,
              responsive: false
            }),
            _react2.default.createElement(_FilterButton2.default, {
              onClick: this.toggleDownloads,
              title: t('Number of downloads'),
              isActive: chartType === CHART_TYPE.downloads,
              responsive: false
            })
          ),
          _react2.default.createElement(_Checkbox2.default, {
            className: styles.citiesCheckbox,
            small: true,
            checked: displayMarkers,
            onClick: this.toggleDisplayMode,
            textAfter: t('Show cities')
          })
        )
      );
    }
  }]);
  return GeographyChartTypeWrapper;
}(_react.PureComponent), _class2.propTypes = {
  citiesDownloadsData: _propTypes2.default.object,
  citiesPlaysData: _propTypes2.default.object,
  countriesDownloadsData: _propTypes2.default.object,
  countriesPlaysData: _propTypes2.default.object,
  id: _propTypes2.default.string,
  loading: _propTypes2.default.bool
}, _class2.contextTypes = {
  t: _propTypes2.default.func
}, _class2.defaultProps = {
  citiesDownloadsData: _statistics.defaultChartData,
  citiesPlaysData: _statistics.defaultChartData,
  countriesDownloadsData: _statistics.defaultChartData,
  countriesPlaysData: _statistics.defaultChartData
}, _temp), (_applyDecoratedDescriptor(_class.prototype, 'togglePlays', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'togglePlays'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'toggleDownloads', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'toggleDownloads'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'toggleDisplayMode', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'toggleDisplayMode'), _class.prototype)), _class);
exports.default = GeographyChartTypeWrapper;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Statistics/GeographyChart/GeographyChartTypeWrapper.js
// module id = 2113
// module chunks = 1